// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"ForgotPassword__materialize-textarea___2RcH5","modal-2463794813":"ForgotPassword__modal-2463794813___3I9Wt","container":"ForgotPassword__container___5dLt3","centerDiv":"ForgotPassword__centerDiv___FFR_F","holder":"ForgotPassword__holder___2H3r-","joinUsContainer":"ForgotPassword__joinUsContainer___3iyN8","joinUsBanner":"ForgotPassword__joinUsBanner___30x2f","joinUsDetails":"ForgotPassword__joinUsDetails___3PPAk","forgotPasswordSucess":"ForgotPassword__forgotPasswordSucess___1QKZd","successFull":"ForgotPassword__successFull___17r3S"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForgotPassword/ForgotPassword.scss
// module id = 1575
// module chunks = 0